import React from 'react';
import Link from 'next/link';
import { makeStyles } from 'tss-react/mui';
import palette from '@ui/palette';
import Button from '@ui/Button';
import Icon from '@ui/Icon';
import { useLayoutContext } from '../../context/LayoutContext';

const useStyles = makeStyles()(theme => ({
  root: {
    transition: theme.transitions.create(['padding'], {
      easing: 'cubic-bezier(0, 0, 0.2, 1)',
      duration: 800,
    }),
    height: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px',
    alignSelf: 'start',
  },
  logo: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
    borderRadius: theme.spacing(0.5),
  },
  outlineOffset: {
    '&.Mui-focusVisible': {
      outline: `2px solid ${palette.mint_200}`,
      '&:not(&[data-hide-focus])': {
        outline: `2px solid ${palette.mint_200}`,
        outlineOffset: -1,
      },
    },
  },
}));

/**
 * @description provides the logo and the left rail collapse button; this should be used as the first
 *              element in the navigation list.
 */
export default function NavigationHeader() {
  const { toggleLeftRail, isLeftRailOpen } = useLayoutContext();
  const { classes, cx } = useStyles();

  return (
    <div className={classes.root}>
      <Link href={'/dashboard/projects'} className={cx(classes.outlineOffset)}>
        <img
          src="/static/images/logo/v2/mark.svg"
          className={cx(classes.logo, classes.outlineOffset)}
          alt="WellSaid logo"
        />
      </Link>
      {isLeftRailOpen && (
        <Button
          variant="icon"
          aria-label="main navigation close icon"
          className={classes.outlineOffset}
          color="action"
          style={{
            padding: '4px 4px 4px 5px',
            display: isLeftRailOpen ? '' : 'none',
          }}
          onClick={toggleLeftRail}
        >
          <Icon type="alignLeft01" style={{ color: palette.gray_0 }} />
        </Button>
      )}
    </div>
  );
}
